import cookie from 'js-cookie';
import cookieExists from './util/cookie_exists';

export const SAVED_BUILDING_LIST_COOKIE = '__we_my-saved--buildings';
export const SAVED_BUILDING_MAX_COUNT = 25; // [GROW-10444] Pick a more intentional number, this one is arbitrary
const DAYS_TO_EXPIRE = 60;

export function toggleBuilding(buildingUuid) {
  if (isBuildingSaved(buildingUuid)) {
    unsaveBuilding(buildingUuid);
  } else {
    saveBuilding(buildingUuid);
  }
}

export function isBuildingSaved(buildingUuid) {
  if (!cookieExists(SAVED_BUILDING_LIST_COOKIE)) {
    // They don't have the cookie, so no point in checking
    return false;
  }

  // They have the cookie, but is the building in it?
  const listOfBuildings = JSON.stringify(cookie.get(SAVED_BUILDING_LIST_COOKIE));
  return listOfBuildings.includes(buildingUuid);
}

export function saveBuilding(buildingUuid) {
  // Bad things happen if we try to parse a cookie that doesn't exist
  if (!cookieExists(SAVED_BUILDING_LIST_COOKIE)) {
    createSavedBuildingCookie();
    return saveBuilding(buildingUuid);
  }

  // Cookie is stored as JSON array
  const currentCookie = cookie.get(SAVED_BUILDING_LIST_COOKIE);
  const currentList = JSON.parse(currentCookie);
  const buildingCount = currentList.length;

  if (!isBuildingSaved(buildingUuid) && buildingCount < SAVED_BUILDING_MAX_COUNT) {
    currentList.push(buildingUuid);

    // Overwrite cookie contents with new, expanded list
    setSavedBuildingCookie(JSON.stringify(currentList));
  }

  window.dispatchEvent(new CustomEvent('buildingSaved', { detail: { id: buildingUuid } }));
}

export function unsaveBuilding(buildingUuid) {
  // Normally, we should never be unsaving without a cookie, but we should protect against it
  if (!cookieExists(SAVED_BUILDING_LIST_COOKIE)) {
    createSavedBuildingCookie();
  }

  const currentList = getSavedBuildingIds();

  if (isBuildingSaved(buildingUuid)) {
    const index = currentList.indexOf(buildingUuid);

    if (index > -1) {
      // Splice out the one building; doesn't matter where it is in array
      currentList.splice(index, 1);
    }

    // Set cookie to new, shortened list
    setSavedBuildingCookie(JSON.stringify(currentList));
  }
  window.dispatchEvent(new CustomEvent('buildingUnsaved', { detail: { id: buildingUuid } }));
}

export function savedBuildingCount() {
  let count = 0;

  if (cookieExists(SAVED_BUILDING_LIST_COOKIE)) {
    count = JSON.parse(cookie.get(SAVED_BUILDING_LIST_COOKIE)).length;
  }

  return count;
}

function createSavedBuildingCookie() {
  setSavedBuildingCookie('[]');
}

function setSavedBuildingCookie(value) {
  cookie.set(SAVED_BUILDING_LIST_COOKIE, value, {
    expires: DAYS_TO_EXPIRE,
    sameSite: 'lax',
    path: '/' // Just to make sure a browser doesn't set it to something else by default
  });
}

export function getSavedBuildingIds() {
  if (cookieExists(SAVED_BUILDING_LIST_COOKIE)) {
    return JSON.parse(cookie.get(SAVED_BUILDING_LIST_COOKIE));
  }
  return [];
}
